import { Button } from "@/components/ui/button";
import { EyeIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

export const ViewRowButton: React.FC<{
  onClickView: () => void;
}> = ({ onClickView }) => {
  const { t } = useTranslation();

  return (
    <Button
      variant="outline"
      onClick={() => onClickView()}
      size="sm"
      className="flex items-center gap-1 transition-all hover:scale-105 hover:bg-primary hover:text-primary-foreground"
    >
      {t("common.view")} <EyeIcon className="w-2 h-2" />
    </Button>
  );
};
